if(!window._rails_loaded){
  const Rails = require("@rails/ujs").default
  Rails.start()
}
import 'jquery-mask-plugin'
import '../stylesheets/session.scss'
import '../scripts/components/utils'
import '../scripts/devise/footer'
import '../scripts/devise/navbar'
import '../scripts/devise/signup'
import '../scripts/devise/internal_sso_login'
